import { currentPoliciesResponseSchema, type CurrentPoliciesResponse } from '@teentack/shared';
import { apiFetch, post } from '@/lib/api-client';

/**
 * The policy versions in force, and whether this account has accepted them.
 * [Admin step 18, the accepting half]
 */
export async function fetchCurrentPolicies(): Promise<CurrentPoliciesResponse> {
  return currentPoliciesResponseSchema.parse(await apiFetch<unknown>('/policies'));
}

export async function acceptPolicy(policyId: string): Promise<void> {
  await post(`/policies/${policyId}/accept`, {});
}
